export const BREAKPOINTS = {
  SM: 528,
  MD: 792,
  LG: 1024,
  XL: 1025,
}

export const CUSTOM_DYNAMIC_BULLETS = {
  enabled: true,
  visibleBullets: 5,
}

export const PAGINATION = {
  // We use custom dynamic bullets implementation
  dynamicBullets: false,
}
